import { Mail, CreditCard } from "lucide-react";
import PropTypes from "prop-types";

/**
 * Bottom "Stato Email + Stato Card Digitali" panel for the Admin Dashboard.
 * Extracted from `AdminDashboard.js` (refactor 22 Feb 2026 — pure code move).
 */
export const AdminStatusBreakdown = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <div className="wallet-card">
        <h3 className="text-xl font-semibold mb-6 flex items-center gap-2"><Mail className="text-lojack-red" />Stato Email</h3>
        <div className="space-y-4">
          {[
            { label: 'In attesa', key: 'emails_pending', color: 'bg-gray-500' },
            { label: 'Inviate', key: 'emails_sent', color: 'bg-blue-500' },
            { label: 'Consegnate', key: 'emails_delivered', color: 'bg-lojack-blue-500' },
            { label: 'Lette', key: 'emails_read', color: 'bg-lojack-blue-500' },
            { label: 'Fallite', key: 'emails_failed', color: 'bg-red-500' },
          ].map(item => (
            <div key={item.key} className="flex justify-between items-center">
              <span className="text-gray-400">{item.label}</span>
              <div className="flex items-center gap-3">
                <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden">
                  <div className={`h-full ${item.color} rounded-full`} style={{ width: `${stats?.total_customers ? (stats[item.key] / stats.total_customers) * 100 : 0}%` }}></div>
                </div>
                <span className="text-white font-medium w-8 text-right">{stats?.[item.key] || 0}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="wallet-card">
        <h3 className="text-xl font-semibold mb-6 flex items-center gap-2"><CreditCard className="text-lojack-red" />Stato Card Digitali</h3>
        <div className="space-y-4">
          {[
            { label: 'Non create', key: 'cards_not_created', color: 'bg-gray-500' },
            { label: 'Create', key: 'cards_created', color: 'bg-blue-500' },
            { label: 'Nel Wallet', key: 'cards_added_to_wallet', color: 'bg-lojack-blue-500' },
          ].map(item => (
            <div key={item.key} className="flex justify-between items-center">
              <span className="text-gray-400">{item.label}</span>
              <div className="flex items-center gap-3">
                <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden">
                  <div className={`h-full ${item.color} rounded-full`} style={{ width: `${stats?.total_customers ? (stats[item.key] / stats.total_customers) * 100 : 0}%` }}></div>
                </div>
                <span className="text-white font-medium w-8 text-right">{stats?.[item.key] || 0}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 pt-6 border-t border-gray-700">
          <div className="flex justify-between items-center">
            <span className="text-gray-400">Termini Accettati</span>
            <span className="text-lojack-blue-400 font-semibold">{stats?.terms_accepted || 0}</span>
          </div>
          <div className="flex justify-between items-center mt-3">
            <span className="text-gray-400">Contratti Firmati</span>
            <span className="text-purple-400 font-semibold">{stats?.contracts_signed || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminStatusBreakdown;

AdminStatusBreakdown.propTypes = {
  stats: PropTypes.object,                     // KPI breakdown — component guards null internally
};
